import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import styled, { system } from '@xstyled/styled-components';
import { Tabs } from 'antd';
import { jsx as _jsx } from "react/jsx-runtime";
var TabPane = Tabs.TabPane;
var StyledTab = styled(Tabs)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), system);
var TabContentContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  min-height: 200px;\n  width: 100%;\n  display: flex;\n  overflow-x: auto;\n  ", ";\n"])), system);
var StyledTabPane = styled(TabPane)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([""])));
export var RootTab = function RootTab(props) {
  var size = props.size,
      type = props.type,
      defaultActiveKey = props.defaultActiveKey,
      tabItems = props.tabItems,
      paneStyle = props.paneStyle;
  return /*#__PURE__*/_jsx(StyledTab, _objectSpread(_objectSpread({}, props), {}, {
    defaultActiveKey: defaultActiveKey || tabItems[0].key,
    size: size !== null && size !== void 0 ? size : 'middle',
    type: type !== null && type !== void 0 ? type : 'line',
    children: tabItems.map(function (pane) {
      return /*#__PURE__*/_jsx(StyledTabPane, {
        style: paneStyle,
        tab: pane.title,
        children: /*#__PURE__*/_jsx(TabContentContainer, {
          children: pane.content
        })
      }, pane.key);
    })
  }));
};